export default {
  name: 'mobileprompt',
  title: '提示',
  data() {
    return {};
  },
  methods: {}
};